import script from "./GlobusTableNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobusTableNavbar.vue?vue&type=script&setup=true&lang=js"

import "./GlobusTableNavbar.vue?vue&type=style&index=0&id=a14021c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a14021c4"]])

export default __exports__